import React, { useState } from "react";

export default function DeleteAccount() {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [reason, setReason] = useState("");
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (confirmDelete && phoneNumber) {
      // Here you would typically send this to your backend
      setSubmitted(true);
    }
  };

  if (submitted) {
    return (
      <main className="page">
        <div
          style={{
            background: "#ffffff",
            padding: 32,
            borderRadius: 16,
            textAlign: "center",
            boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
          }}
        >
          <div style={{ fontSize: 48, marginBottom: 16 }}>✓</div>
          <h1 style={{ color: "var(--primary)", marginBottom: 12 }}>
            Request Received
          </h1>
          <p>
            We've received your account deletion request. Our team will process it
            within 7 business days. You'll receive a confirmation SMS once your
            account has been permanently deleted.
          </p>
          <a
            href="/"
            style={{
              display: "inline-block",
              marginTop: 20,
              color: "var(--primary)",
              textDecoration: "none",
              fontWeight: "bold",
            }}
          >
            ← Back to Home
          </a>
        </div>
      </main>
    );
  }

  return (
    <main className="page">
      <h1>Delete Account</h1>
      <p style={{ fontSize: 15, lineHeight: 1.6, marginBottom: 24 }}>
        We're sorry to see you go. If you'd like to delete your 7BOX account,
        please fill out the form below. This action cannot be undone.
      </p>

      {/* WARNING BOX */}
      <div
        style={{
          background: "#fff3cd",
          border: "1px solid #ffc107",
          padding: 16,
          borderRadius: 12,
          marginBottom: 28,
        }}
      >
        <p style={{ margin: 0, fontSize: 14, lineHeight: 1.6 }}>
          <strong>⚠️ Important:</strong> Deleting your account will permanently
          remove all your data, including order history, saved addresses, and
          preferences. This action cannot be reversed.
        </p>
      </div>

      {/* WHAT HAPPENS SECTION */}
      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: 20, marginBottom: 12 }}>
          What happens when you delete your account?
        </h2>
        <ul>
          <li>All personal information will be permanently deleted</li>
          <li>Order history and transaction records will be removed</li>
          <li>Saved addresses and payment methods will be deleted</li>
          <li>You will no longer receive order updates or notifications</li>
          <li>You'll need to create a new account to use 7BOX again</li>
        </ul>
      </section>

      {/* ALTERNATIVES */}
      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: 20, marginBottom: 12 }}>
          Before you go...
        </h2>
        <div
          style={{
            background: "#ffffff",
            padding: 16,
            borderRadius: 12,
            marginBottom: 14,
            boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
          }}
        >
          <h3 style={{ marginTop: 0, fontSize: 16 }}>Consider these alternatives:</h3>
          <ul style={{ marginBottom: 0 }}>
            <li>Disable notifications instead of deleting your account</li>
            <li>Remove saved payment methods if privacy is a concern</li>
            <li>Contact support if you're experiencing issues</li>
          </ul>
        </div>
      </section>

      {/* DELETE FORM */}
      <section>
        <h2 style={{ fontSize: 20, marginBottom: 12 }}>
          Request Account Deletion
        </h2>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 20 }}>
            <label
              htmlFor="phoneNumber"
              style={{
                display: "block",
                marginBottom: 8,
                fontWeight: "bold",
                fontSize: 14,
              }}
            >
              Registered Phone Number *
            </label>
            <input
              type="tel"
              id="phoneNumber"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              required
              style={{
                width: "100%",
                padding: "12px 14px",
                borderRadius: 8,
                border: "1px solid #ddd",
                fontSize: 15,
                fontFamily: "inherit",
              }}
              placeholder="Enter your registered phone number"
            />
          </div>

          <div style={{ marginBottom: 20 }}>
            <label
              htmlFor="reason"
              style={{
                display: "block",
                marginBottom: 8,
                fontWeight: "bold",
                fontSize: 14,
              }}
            >
              Reason for Deletion (Optional)
            </label>
            <textarea
              id="reason"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              rows="4"
              style={{
                width: "100%",
                padding: "12px 14px",
                borderRadius: 8,
                border: "1px solid #ddd",
                fontSize: 15,
                fontFamily: "inherit",
                resize: "vertical",
              }}
              placeholder="Help us improve by sharing why you're leaving..."
            />
          </div>

          <div style={{ marginBottom: 24 }}>
            <label
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: 12,
                cursor: "pointer",
              }}
            >
              <input
                type="checkbox"
                checked={confirmDelete}
                onChange={(e) => setConfirmDelete(e.target.checked)}
                required
                style={{
                  marginTop: 4,
                  width: 18,
                  height: 18,
                  cursor: "pointer",
                }}
              />
              <span style={{ fontSize: 14, lineHeight: 1.5 }}>
                I understand that deleting my account is permanent and cannot be
                undone. I confirm that I want to proceed with account deletion. *
              </span>
            </label>
          </div>

          <button
            type="submit"
            disabled={!confirmDelete || !phoneNumber}
            style={{
              width: "100%",
              background: confirmDelete && phoneNumber ? "#dc3545" : "#ccc",
              color: "#fff",
              padding: "14px",
              borderRadius: 8,
              border: "none",
              fontSize: 16,
              fontWeight: "bold",
              cursor: confirmDelete && phoneNumber ? "pointer" : "not-allowed",
              transition: "background 0.2s",
            }}
          >
            Delete My Account
          </button>
        </form>

        <p
          style={{
            textAlign: "center",
            marginTop: 20,
            fontSize: 13,
            color: "#777",
          }}
        >
          Need help? <a href="/" style={{ color: "var(--primary)" }}>Contact Support</a>
        </p>
      </section>
    </main>
  );
}
